import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import { backend_url } from "../../App";

import img0 from "../Assets/hero_image.png";
import img1 from "../Assets/banner_mens.png";
import img2 from "../Assets/banner_women.png";
import img3 from "../Assets/banner_kids.png";

const DEFAULT_IMAGES = [img0, img1, img2, img3];

const DEFAULT_SLIDES = [
  {
    id: 1,
    image: img0,
    category: "Laptops & PCs",
    tag: "ðŸ”¥ Up to 40% OFF",
    title: "Premium Laptops",
    subtitle: "Dell, HP, Lenovo, Apple â€” top brands, fast delivery, best price.",
    btnLabel: "Shop Laptops",
    btnLink: "/laptops",
    accent: "#00d4ff",
  },
  {
    id: 2,
    image: img1,
    category: "Smartphones",
    tag: "âš¡ Flash Deal",
    title: "Latest Smartphones",
    subtitle: "iPhone, Samsung, Xiaomi & more. Sealed box, genuine warranty.",
    btnLabel: "Shop Phones",
    btnLink: "/phones",
    accent: "#7c3aed",
  },
  {
    id: 3,
    image: img2,
    category: "Audio & Wearables",
    tag: "ðŸŽ§ New Arrivals",
    title: "Premium Audio Gear",
    subtitle: "Sony, JBL, AirPods â€” noise cancelling & wireless sound perfected.",
    btnLabel: "Explore Audio",
    btnLink: "/accessories",
    accent: "#f472b6",
  },
  {
    id: 4,
    image: img3,
    category: "Gaming Zone",
    tag: "ðŸŽ® New Stock",
    title: "Gaming Accessories",
    subtitle: "Controllers, headsets, gaming phones â€” level up your setup today.",
    btnLabel: "Shop Gaming",
    btnLink: "/accessories",
    accent: "#22c55e",
  },
];

const DEFAULT_TICKERS = [
  "âš¡ Flash Sale â€” Up to 40% OFF on Laptops",
  "ðŸš€ Free Shipping on orders above Rs. 2,000",
  "ðŸŽ New arrivals every week â€” Don't miss out",
  "ðŸ”’ 100% Secure Payment Â· Easy 30-day returns",
];

const Hero = () => {
  const [slides, setSlides] = useState(DEFAULT_SLIDES);
  const [tickers, setTickers] = useState(DEFAULT_TICKERS);
  const [current, setCurrent] = useState(0);
  const [transitioning, setTransitioning] = useState(false);

  useEffect(() => {
    fetch(`${backend_url}/homecontent`)
      .then(r => r.json())
      .then(data => {
        if (data.heroSlides?.length) {
          setSlides(data.heroSlides.map((sl, i) => ({
            id: i + 1,
            ...sl,
            image: sl.image || DEFAULT_IMAGES[i % DEFAULT_IMAGES.length],
          })));
        }
        if (data.tickers?.length) setTickers(data.tickers);
      })
      .catch(() => {});
  }, []);

  const goTo = useCallback(
    (idx) => {
      if (transitioning) return;
      setTransitioning(true);
      setTimeout(() => {
        setCurrent(idx);
        setTransitioning(false);
      }, 350);
    },
    [transitioning]
  );

  const next = useCallback(() => goTo((current + 1) % slides.length), [current, goTo, slides.length]); // eslint-disable-line react-hooks/exhaustive-deps
  const prev = useCallback(() => goTo((current - 1 + slides.length) % slides.length), [current, goTo, slides.length]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const t = setInterval(next, 5000);
    return () => clearInterval(t);
  }, [next]);

  const s = slides[current % slides.length] || slides[0];

  return (
    <div className="bg-[#060c18]">
      {/* Announcement ticker */}
      <div
        className="relative overflow-hidden py-2.5 border-b border-white/[0.06]"
        style={{ background: "linear-gradient(90deg,#0a0f1e,#0d1526,#0a0f1e)" }}
      >
        <div className="flex" style={{ animation: "scroll-x 22s linear infinite", width: "max-content" }}>
          {[...tickers, ...tickers].map((t, i) => (
            <span key={i} className="flex-shrink-0 text-[#8896a6] text-[12px] font-medium px-10 whitespace-nowrap">
              {t} <span className="text-[#2a3547] mx-4">|</span>
            </span>
          ))}
        </div>
        <style>{`@keyframes scroll-x{0%{transform:translateX(0)}100%{transform:translateX(-50%)}}`}</style>
      </div>

      {/* Full-screen image slider */}
      <div
        className="relative w-full overflow-hidden"
        style={{ height: "88vh", minHeight: "480px", maxHeight: "820px" }}
      >
        {/* Slide background images */}
        {slides.map((sl, i) => (
          <div
            key={sl.id}
            className="absolute inset-0 bg-cover bg-center bg-no-repeat"
            style={{
              backgroundImage: `url(${sl.image})`,
              opacity: i === current ? 1 : 0,
              transition: "opacity 0.5s ease",
            }}
          />
        ))}

        {/* Bottom gradient â€” keeps image visible on top, dark at bottom for text */}
        <div
          className="absolute inset-0 pointer-events-none"
          style={{
            background:
              "linear-gradient(to top, rgba(6,12,24,0.97) 0%, rgba(6,12,24,0.6) 38%, rgba(6,12,24,0.15) 65%, transparent 100%)",
          }}
        />
        {/* Left gradient â€” text readability */}
        <div
          className="absolute inset-0 pointer-events-none"
          style={{
            background:
              "linear-gradient(to right, rgba(6,12,24,0.82) 0%, rgba(6,12,24,0.35) 38%, transparent 60%)",
          }}
        />

        {/* Slide content â€” bottom left */}
        <div
          className="absolute bottom-0 left-0 px-[7%] pb-[72px] z-10 max-[600px]:pb-[80px]"
          style={{
            opacity: transitioning ? 0 : 1,
            transform: transitioning ? "translateY(12px)" : "translateY(0)",
            transition: "opacity 0.35s ease, transform 0.35s ease",
          }}
        >
          <div className="max-w-[580px]">
            {/* Category tag */}
            <span
              className="inline-block text-[10px] font-extrabold tracking-[2px] uppercase px-3.5 py-1.5 rounded-full border mb-3"
              style={{
                color: s.accent,
                borderColor: `${s.accent}55`,
                background: `${s.accent}18`,
              }}
            >
              {s.category}
            </span>

            {/* Deal badge */}
            <div className="mb-3">
              <span
                className="text-[11px] font-bold tracking-[1px] px-3 py-1 rounded-full"
                style={{ background: `${s.accent}25`, color: s.accent }}
              >
                {s.tag}
              </span>
            </div>

            {/* Product title */}
            <h1
              className="text-[52px] font-black text-white leading-[1.05] mb-3 -tracking-[1.5px] max-[900px]:text-[38px] max-[600px]:text-[28px]"
            >
              {s.title}
            </h1>

            {/* Short product subtitle */}
            <p
              className="text-[#b0bccf] text-[15px] leading-[1.65] mb-7 max-w-[440px] max-[600px]:text-[13px] max-[600px]:mb-5"
            >
              {s.subtitle}
            </p>

            {/* Shop Now button */}
            <Link to={s.btnLink}>
              <button
                className="inline-flex items-center gap-2.5 h-[52px] px-8 rounded-xl border-none font-extrabold text-[15px] cursor-pointer font-[inherit] transition-all duration-200 hover:-translate-y-0.5 hover:scale-[1.02] max-[600px]:h-11 max-[600px]:px-6 max-[600px]:text-[14px]"
                style={{
                  background: `linear-gradient(135deg, ${s.accent} 0%, ${s.accent}bb 100%)`,
                  boxShadow: `0 8px 28px ${s.accent}44`,
                  color: ["#00d4ff", "#f472b6"].includes(s.accent) ? "#060c18" : "#fff",
                }}
              >
                {s.btnLabel}
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                  <path d="M5 12h14M12 5l7 7-7 7" />
                </svg>
              </button>
            </Link>
          </div>
        </div>

        {/* Prev arrow */}
        <button
          onClick={prev}
          aria-label="Previous slide"
          className="absolute top-1/2 -translate-y-1/2 left-4 z-20 w-10 h-10 rounded-full flex items-center justify-center border border-white/15 text-white backdrop-blur-md transition-all hover:bg-white/15 hover:border-white/40 cursor-pointer max-[500px]:hidden"
          style={{ background: "rgba(6,12,24,0.55)" }}
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
            <path d="M19 12H5M12 19l-7-7 7-7" />
          </svg>
        </button>

        {/* Next arrow */}
        <button
          onClick={next}
          aria-label="Next slide"
          className="absolute top-1/2 -translate-y-1/2 right-4 z-20 w-10 h-10 rounded-full flex items-center justify-center border border-white/15 text-white backdrop-blur-md transition-all hover:bg-white/15 hover:border-white/40 cursor-pointer max-[500px]:hidden"
          style={{ background: "rgba(6,12,24,0.55)" }}
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
            <path d="M5 12h14M12 5l7 7-7 7" />
          </svg>
        </button>

        {/* Dot indicators â€” bottom right */}
        <div className="absolute bottom-6 right-[7%] z-20 flex items-center gap-2">
          {slides.map((sl, i) => (
            <button
              key={sl.id}
              onClick={() => goTo(i)}
              aria-label={`Slide ${i + 1}`}
              className="rounded-full border-none cursor-pointer p-0 transition-all duration-300"
              style={
                i === current
                  ? { width: "28px", height: "6px", background: s.accent }
                  : { width: "6px", height: "6px", background: "rgba(255,255,255,0.3)" }
              }
            />
          ))}
        </div>

        {/* Slide counter â€” top right */}
        <div className="absolute top-5 right-[7%] z-20 flex items-center gap-1 text-white/40 text-[13px] font-bold tabular-nums select-none">
          <span style={{ color: s.accent }}>{String(current + 1).padStart(2, "0")}</span>
          <span className="mx-0.5">/</span>
          <span>{String(slides.length).padStart(2, "0")}</span>
        </div>
      </div>
    </div>
  );
};

export default Hero;
